import { render, staticRenderFns } from "./politica_proteccion_datos_personales.vue?vue&type=template&id=674cc8bd&scoped=true&"
import script from "./politica_proteccion_datos_personales.vue?vue&type=script&lang=js&"
export * from "./politica_proteccion_datos_personales.vue?vue&type=script&lang=js&"
import style0 from "./politica_proteccion_datos_personales.vue?vue&type=style&index=0&id=674cc8bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674cc8bd",
  null
  
)

export default component.exports